import { render, staticRenderFns } from "./ModernDashboard.vue?vue&type=template&id=a0e50206&scoped=true"
import script from "./ModernDashboard.vue?vue&type=script&lang=js"
export * from "./ModernDashboard.vue?vue&type=script&lang=js"
import style0 from "./ModernDashboard.vue?vue&type=style&index=0&id=a0e50206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e50206",
  null
  
)

export default component.exports